<template>
  <div class="box">
    <div class="val">
      <span>{{ info.val }}</span>
      <span class="unit">{{ ' ' + info.unit }}</span>
    </div>
    <div class="key">{{ info.key }}</div>
    <div class="after after1"></div>
    <div class="after after2"></div>
    <div class="after after3"></div>
    <div class="after after4"></div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$height: 0.15rem;
.box {
  position: relative;
  width: 0.47rem;
  height: 0.3rem;
  color: #0f69ca;
  background: linear-gradient(
    top,
    rgba(#36dffc, 0) 0%,
    rgba(#36dffc, 0) 30%,
    rgba(#36dffc, 0.6) 100%
  );
}
.val {
  width: 100%;
  margin-top: .08rem;
  height: 0.05rem;
  text-align: center;
  font-size: 0.05rem;
}
.unit {
  font-size: 0.05rem;
}
.key {
  width: 100%;
  margin-top: .02rem;
  height: 0.05rem;
  text-align: center;
  font-size: 0.05rem;
}
.after {
  position: absolute;
  height: 0.05rem;
  width: 0.05rem;
}
$borderstyle: 1px solid rgba(#0f69ca, 0.3);
.after1 {
  left: 0rem;
  top: 0rem;
  border-left: $borderstyle;
  border-top: $borderstyle;
}
.after2 {
  right: 0rem;
  top: 0rem;
  border-right: $borderstyle;
  border-top: $borderstyle;
}
.after3 {
  left: 0rem;
  bottom: 0rem;
  border-left: $borderstyle;
  border-bottom: $borderstyle;
}
.after4 {
  right: 0rem;
  bottom: 0rem;
  border-right: $borderstyle;
  border-bottom: $borderstyle;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/valstatus/card.vue